import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoService } from "@ngneat/transloco";
import { LOGIN_ROUTE } from 'src/app/app-routing.module';
import { environment } from "@environment";
import {
  ActionResult,
  Country,
  EventItem,
  FetchEventByIdRequest,
  Lookups,
  Race
} from "@model";
import {
  AuthenticationService,
  EventRaceService,
  EventService, LoaderService,
  TOAST_STATE,
  ToastService
} from "@services";
import { AbstractComponent } from "../abstract.component";
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-event-grid-item-with-image',
  templateUrl: './event-grid-item-with-image.component.html',
  styleUrls: ['./event-grid-item-with-image.component.scss'],
  providers: [DatePipe]
})
export class EventGridItemWithImage extends AbstractComponent implements OnInit {
  @Input() eventItem: EventItem | undefined;
  @Input() additionalClass: string | undefined;
  @Input() isLanding: boolean = false;
  @Input() isFinishedEvent: boolean = false;
  @Input() countries: Country[] = [];
  @Input() isOnWishList: boolean = false;
  @Input({ required: true }) languages: Lookups[] = [];
  @Input() favoriteItems?: EventItem[];
  @Input() isItemFavorite: boolean = false;
  @Input() isPreviewComponent?: boolean;
  @Input() zoomEffect: boolean = false;

  eventCountry: Country | undefined;
  listSizeBreakpoint: number = environment.eventItemLengthsSizeUiBreakpoint;
  lengths: (string | undefined)[] = [];

  constructor(public translocoService: TranslocoService, private router: Router, private authenticationService: AuthenticationService,
    private offcanvasService: NgbOffcanvas, private eventRaceService: EventRaceService, private datePipe: DatePipe,
    private eventService: EventService, private toastService: ToastService, private loaderService: LoaderService) {
    super();
  }

  ngOnInit(): void {
    this.setEventCountry();
    this.setEventLengths();
    this.isFavorite(this.eventItem);
  }

  isFavorite(item: EventItem | undefined): void {
    if (item) {
      this.isItemFavorite = !!(this.favoriteItems && this.favoriteItems.find(value => item.id === value.id));
    }
  }

  checkSameDate(eventItem: EventItem | undefined): boolean {
    if (eventItem?.start && eventItem.end) {
      let startDate: Date = new Date(eventItem.start);
      let endDate: Date = new Date(eventItem.end);
      return (startDate < endDate) && (startDate.getDate() !== endDate.getDate());
    } else {
      return false;
    }
  }

  setEventCountry(): void {
    if (this.countries !== null && this.countries.length > 0 && this.eventItem && this.eventItem.country) {
      let country: Lookups | undefined = this.countries.find((item: Lookups) => item.id === this.eventItem!.country);
      if (country) {
        this.eventCountry = country;
      }
    }
  }

  setEventLengths(): void {
    this.lengths = this.eventItem?.lengths && ((this.eventItem?.lengths?.length ?? 0) > 0) ? this.eventItem?.lengths?.slice(0, this.listSizeBreakpoint)
      : Array.from(new Set(this.eventItem?.racesList?.map((race: Race) => race.length?.toString()))).slice(0, this.listSizeBreakpoint);
  }

  addToFavoritesButtonClicked(event: MouseEvent): void {
    if(this.isPreviewComponent){
      event.preventDefault()
      event.stopPropagation()
      return;
    }else{
      event.preventDefault()
      event.stopPropagation()
      if (this.authenticationService.isAuthenticated()) {
        this.addToFavoritesAction();
      } else {
        this.toastService.showToast(TOAST_STATE.warning, this.translocoService.translate("event.favorite.save.warning"));
      }
    }
  }

  addToFavoritesAction(): void {
    this.loaderService.startLoading()
    if (this.eventItem?.id) {
      this.eventService.findEventById(new FetchEventByIdRequest(this.eventItem.id)).subscribe((value: EventItem | null) => {
        if (value) {
          if (value.id && value.favorite) {
            this.eventService.removeEventFromFavorites(this.eventItem?.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.eventItem!.favorite = false;
                this.isItemFavorite = false;
                this.eventService.fetchUserFavoritesEvent().subscribe((actionResult: EventItem[]) => {
                  this.favoriteItems = actionResult;
                  this.loaderService.dismissLoading();
                });
              } else {
                this.loaderService.dismissLoading();
              }
            });
            this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.delete.success"));
          } else if (value.id && !value.favorite) {
            this.eventService.addEventToFavorites(value.id).subscribe((actionResult: ActionResult<boolean>) => {
              if (actionResult.result) {
                this.eventItem!.favorite = true;
                this.isItemFavorite = true;
                this.loaderService.dismissLoading();
              } else {
                this.loaderService.dismissLoading();
              }
            });
            this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("event.favorite.save.success"));
          }
        }
      })
    }
  }

  goToLogin(): void {
    this.offcanvasService.dismiss();
    this.router.navigate([LOGIN_ROUTE]);
  }

  formatDate(date: Date | string): string {
    const month = this.datePipe.transform(date, 'MMM');
    return month ? month.slice(0, 3) : '';
  }

  protected readonly environment = environment;
}
